import React from 'react';

import {FormattedAddressType} from 'desktop/types/addressType';

import s from './addressesFacelift.scss';

type PropsType = {
    addresses: FormattedAddressType;
};

/**
 * Address for checkout
 * @param {PropsType} props - Received address components
 * @returns {ReactElement} - Customer address facelift components
 */
export const AddressesFacelift: React.FC<PropsType> = ({addresses}) => {
    const {address, city, code, country, email, name, phone, state} = addresses;

    return (
        <div aria-label="address details" className={s.content}>
            <p>{name}</p>
            <p>
                {address} {city}
            </p>
            <p>
                {code} {state} {country}
            </p>
            <p>{phone}</p>
            <p>{email}</p>
        </div>
    );
};
